import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import Accordion from 'react-bootstrap/Accordion';
import { collection, getDocs, updateDoc, getDoc, setDoc, writeBatch, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig/firebase';
import { Row, Col, Container, Button, Form, Spinner, Alert } from 'react-bootstrap';

import Header from './Header';

function Upload() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });

    // 1. Leer el archivo Excel
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const workbook = XLSX.read(event.target.result, { type: 'binary' });
            const sheetName = workbook.SheetNames[0]; // Tomamos la primera hoja
            const sheet = workbook.Sheets[sheetName];

            // Convertir a formato JSON
            const excelData = XLSX.utils.sheet_to_json(sheet);
            setData(excelData);
        };

        reader.readAsBinaryString(file);
    };

    // 2. Subir a Firestore (Usando Batch para mayor eficiencia)
    const uploadToFirestore = async () => {
        if (data.length === 0) return;
        setLoading(true);

        try {
            const batch = writeBatch(db);
            const collectionRef = collection(db, "tribu-esp"); // Nombre de tu colección

            data.forEach((item) => {
                const newDocRef = doc(collectionRef); // Crea una referencia con ID automático
                batch.set(newDocRef, item);
            });

            await batch.commit();
            setStatus({ type: 'success', msg: `¡Éxito! Se subieron ${data.length} registros.` });
            setData([]);
        } catch (error) {
            console.error("Error al subir:", error);
            setStatus({ type: 'danger', msg: 'Error al subir los datos.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <Container>
                <div className="p-4 border rounded shadow-sm bg-white">
                    <h4>Importar Excel a Firestore</h4>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>Selecciona el archivo .xlsx o .csv</Form.Label>
                        <Form.Control type="file" accept=".xlsx, .xls, .csv" onChange={handleFileUpload} />
                    </Form.Group>

                    {data.length > 0 && (
                        <div className="mb-3">
                            <p className="text-muted small">Registros detectados: {data.length}</p>
                            <Button
                                variant="primary"
                                onClick={uploadToFirestore}
                                disabled={loading}
                            >
                                {loading ? 'Subiendo...' : 'Confirmar y Subir'}
                            </Button>
                        </div>
                    )}

                    {status.msg && <Alert variant={status.type} className="mt-3">{status.msg}</Alert>}
                </div>
                {loading && (
                    <div className="position-fixed bottom-0 end-0 m-4">
                        <Spinner animation="border" variant="primary" />
                    </div>
                )}
            </Container>
        </>


    )
}

export default Upload